const BLOCKED_TAGS = new Set([
  "SCRIPT", "STYLE", "IFRAME", "OBJECT", "EMBED", "FORM", "INPUT",
  "BUTTON", "TEXTAREA", "SELECT", "OPTION", "META", "LINK", "BASE",
]);

const isSafeUrl = (value) => {
  const normalized = [...value.trim()]
    .filter((character) => character.charCodeAt(0) > 31 && character.charCodeAt(0) !== 127 && !/\s/.test(character))
    .join("")
    .toLowerCase();
  return !normalized || normalized.startsWith("http://") || normalized.startsWith("https://")
    || normalized.startsWith("mailto:") || normalized.startsWith("tel:")
    || normalized.startsWith("/") || normalized.startsWith("#");
};

export const sanitizeHtml = (html = "") => {
  if (typeof window === "undefined" || !window.DOMParser) return "";
  const document = new window.DOMParser().parseFromString(String(html), "text/html");

  document.body.querySelectorAll("*").forEach((element) => {
    if (BLOCKED_TAGS.has(element.tagName)) {
      element.remove();
      return;
    }
    [...element.attributes].forEach((attribute) => {
      const name = attribute.name.toLowerCase();
      if (name.startsWith("on") || name === "style" || name === "srcdoc") {
        element.removeAttribute(attribute.name);
      } else if (["href", "src", "action", "formaction"].includes(name) && !isSafeUrl(attribute.value)) {
        element.removeAttribute(attribute.name);
      } else if (name !== "data-copy-code" && name.startsWith("data-")) {
        element.removeAttribute(attribute.name);
      }
    });
    if (element.tagName === "A") {
      element.setAttribute("rel", "noopener noreferrer");
      element.setAttribute("target", "_blank");
    }
  });

  return document.body.innerHTML;
};
